(function () {
  'use strict';

  angular
    .module('iqxCore')
    .service('loginSvc', loginSvc)

  function loginSvc(ApiSvc, ApplicationSvc, inactivitySvc, pinSvc, $cookies, $http, $window, SweetAlert, $q, $location, dataSvc, menuSvc, serviceWorkerSvc, BehaviourSvc) {
    var svc = this
    svc.setLoggedIn = setLoggedIn
    svc.setLoggedOut = setLoggedOut
    svc.getClientDivision = getClientDivision

    ///////////

    function setLoggedIn(LoginData, onRegistration) {
      var onRegistration = onRegistration || false
      ApplicationSvc.preventNavIfEditing = false
      ApplicationSvc.currentUser = LoginData.IQXResult
      ApplicationSvc.currentUser.token = LoginData.token
      ApplicationSvc.currentUser.forceChangePassword = LoginData.forceChangePassword
      ApplicationSvc.currentUser.UserRights = makeArray(ApplicationSvc.currentUser.UserRights)
      ApplicationSvc.currentUser.Switches = makeArray(ApplicationSvc.currentUser.Switches)
      $http.defaults.headers.common['X-Auth'] = LoginData.token
      ApplicationSvc.currentUser.personID = "" // sql procedures are set up to interprate an empty string as Null, so setting to empty stirng so we can always pass in without having to check if it is defined.
      if (ApplicationSvc.isSwitchedOn("AUTO_LOGOUT")) {
        inactivitySvc.enable()
      }

      if (ApplicationSvc.currentUser.UserClass === "CANDIDATE") { // they are a candidate so need to check for onRegistration compleate and multiple acounts
        var deferred = $q.defer()
        checkCandidate(deferred, onRegistration)
        return deferred.promise
      } else { // they are not a candidate so just log them in
        // dont save just now, save once login sucessfull Persist login details until session is ended or explicitly logged out i.e. they survive a browser refresh
        if (ApplicationSvc.params.USETEMPSESSIONS == true) {
          $window.sessionStorage.setItem('IQXSession', JSON.stringify(ApplicationSvc.currentUser))
        } else {
          $cookies.putObject('IQXSession', ApplicationSvc.currentUser, ApplicationSvc.cookieOptions)
        }
        menuSvc.update()
        ApplicationSvc.isLoggedIn = true
        return $q.resolve()
      }
    }

    function getClientDivision() {
      var fetchScope = {}
      return ApiSvc.fetch(fetchScope, {
        fetchAPI: 'callresult/NetClientDivision',
        fetchTarget: 'clientDivID',
        multiRow: false,
        booleanFields: ['DepartmentPerm', 'DepartmentTemp']
      })
        .then(function () {
          ApplicationSvc.currentUser.divisionid = fetchScope.clientDivID.divisionid
        })
    }

    function checkCandidate(deferred, onRegistration) {
      var fetchScope = {}
      ApiSvc.fetch(fetchScope, {
        fetchAPI: 'callresult/NetCandidateGetRegistrationComplete?pPersonID=' + ApplicationSvc.currentUser.personID,
        fetchTarget: 'reg',
        numberFields: ['isComplete'],
        multiRow: false,
        notLoggedIn: true // http default headers set but applicationSvc isLoggedIn still false, so need this but procedure still authenticated (dont add to unauthenticated list).
      })
        .then(function () {
          return ApiSvc.fetch(fetchScope, {
            fetchAPI: 'callresult/NetCandidateRegDetails?pPersonID=' + (ApplicationSvc.currentUser.personID),
            fetchTarget: 'regDets',
            multiRow: false,
            booleanFields: ['DepartmentPerm', 'DepartmentTemp'],
            notLoggedIn: true // http default headers set but applicationSvc isLoggedIn still false, so need this but procedure still authenticated (dont add to unauthenticated list).
          }).then(function () {
            ApplicationSvc.currentUser.registrationDetails = fetchScope.regDets
          })
        })
        .then(BehaviourSvc.get)
        .then(function () {
          var regStatus = fetchScope.reg.isComplete
          if (regStatus === 1 || (regStatus === 2 && localStorage.getItem('personid'))) { // they are registered OR (Multi person link but we know the ID they are going in as)
            ApplicationSvc.currentUser.personID = localStorage.getItem('personid') || fetchScope.reg.personid
            if (ApplicationSvc.params.USETEMPSESSIONS) {
              $window.sessionStorage.setItem('IQXSession', JSON.stringify(ApplicationSvc.currentUser))
            } else {
              $cookies.putObject('IQXSession', ApplicationSvc.currentUser, ApplicationSvc.cookieOptions)
            }
            menuSvc.update()
            ApplicationSvc.isLoggedIn = true
            deferred.resolve()
          } else if (regStatus === 0) { // they are part registered
            ApplicationSvc.currentUser.personID = fetchScope.reg.personid // required for various things AFTER reg, as we dont re-set the personID
            if (ApplicationSvc.params.USETEMPSESSIONS) {
              $window.sessionStorage.setItem('IQXSession', JSON.stringify(ApplicationSvc.currentUser))
            } else {
              $cookies.putObject('IQXSession', ApplicationSvc.currentUser, ApplicationSvc.cookieOptions)
            }
            menuSvc.update()
            ApplicationSvc.currentUser.personID = fetchScope.reg.personid
            ApplicationSvc.isLoggedIn = true
            if (!onRegistration) {
              // deferred.reject("partreg") // reject promise as login was successful but they need to finish onRegistration
              if (fetchScope.reg.wizardID) {  // There is an uncompleted soft wizard
                $location.url("/xregister?id=" + fetchScope.reg.wizardID + "&action=resume")
              } else {
                $location.url("/register")
              }
            } else {
              deferred.resolve() // resolve promise as onRegistration is set to true which means they are on reg wizard already to finish registering
            }

          } else if (regStatus === 2) { // multiple person records accosiated with login
            chooseAccount(deferred, onRegistration)
          } else if (regStatus === (-1)) { // no valid link for personID!
            setLoggedOut()
            deferred.reject("No valid link for personID")
            SweetAlert.swal({
              title: "",
              text: "Your account is not currently active, please contact your agency for more information.",
              type: "error"
            })
          }
        })
        .then(BehaviourSvc.get)
        .then(function () {
          var behaviourCookie = $cookies.getObject('IQXBehaviour')
          ApplicationSvc.params.behaviour = angular.fromJson(behaviourCookie)
        })


    }

    function chooseAccount(deferred, onRegistration) {
      SweetAlert.swal({
        title: "<div><div class='alert alert-info' style='width:100%; font-size:16px; font-weight:normal;'>Some features of the website will show just the selected account's details and other pages will show a merge of both - If there is any confusion please contact the agency.</div><h2>Select Account</h2></div>",
        confirmButtonText: "Select account",
        confirmButtonColor: "#337ab7",
        text: 'There are multiple accounts attached to your login.  Please select the one you would like to use.',
        input: 'radio',
        inputClass: 'iqx-select-accounts',
        allowOutsideClick: false,
        allowEscapeKey: false,
        inputOptions: linkedRecords(),
        inputValidator: function (value) { return !value && 'Please select an account from the list above.' }
      }).then(function (result) {
        ApplicationSvc.currentUser.personID = result.value
        checkCandidate(deferred, onRegistration)
      })
    }

    function linkedRecords() {
      var deferred = $q.defer()
      var fetchScope = {}
      ApiSvc.fetch(fetchScope, {
        fetchAPI: 'callresult/NetCandidateLinkedRecords',
        fetchTarget: 'linkedRecords',
        booleanFields: ['UnRegistered'],
        multiRow: true,
        notLoggedIn: true // http default headers set but applicationSvc isLoggedIn still false, so need this but procedure still authenticated (dont add to unauthenticated list).
      }).then(function () {
        var inputOptions = {}
        angular.forEach(fetchScope.linkedRecords, function (value) {
          inputOptions[value.PersonID] = "<div>Name: <strong>" + value.Name + "</strong></div>"
          inputOptions[value.PersonID] += "<div>Address: <strong>" + value.Address + "</strong></div>"
          inputOptions[value.PersonID] += "<div>Division: <strong>" + value.Division + "</strong></div>"
          inputOptions[value.PersonID] += "<div>Tax Method: <strong>" + value.TaxMethod + "</strong></div>"
          if (value.UnRegistered) {
            inputOptions[value.PersonID] += "<div class='label label-warning'>Registration Not Complete</div>"
          } else {
            inputOptions[value.PersonID] += "<div class='label label-success'>Registration Completed on " + moment(value.RegistrationDate).format('DD/MM/YYYY') + "</div>"
          }
        })
        deferred.resolve(inputOptions)
      })

      return deferred.promise
    }

    function makeArray(s) {
      return (s ? s.split(',') : [])
    }

    async function setLoggedOut() {
      inactivitySvc.disable()
      iziToast.destroy() // remove any toast notifications
      SweetAlert.swal.close() // remove any sweet alerts
      dataSvc.reset() // reset data service to remove any sensitive data
      await serviceWorkerSvc.turnOff() // Disable service worker + push notifications etc...
      menuSvc.clear()
      $window.sessionStorage.removeItem('IQXToken')
      $window.sessionStorage.removeItem('IQXSession')
      $cookies.remove('IQXSession')
      $cookies.remove('IQXBehaviour')
      delete $http.defaults.headers.common['X-Auth']
      ApplicationSvc.currentUser = {}
      ApplicationSvc.isLoggedIn = false
      ApplicationSvc.preventNavIfEditing = false
    }

  }

})()